import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiConService } from '../shared/api-con.service';
import { TruckInfoService } from '../truck-info/truck-info.service';
import { SvgService } from '../shared/svg.service';
import { DomSanitizer } from '@angular/platform-browser';

import { BoxListTruckService } from '../box-list-truck/box-list-truck.service';
import { NgStyle, NgIf, NgFor, NgClass, DecimalPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-popup-precos-praca-pedagio',
    templateUrl: './popup-precos-praca-pedagio.component.html',
    styleUrls: ['./popup-precos-praca-pedagio.component.css'],
    standalone: true,
    imports: [NgStyle, NgIf, NgFor, NgClass, DecimalPipe, DatePipe]
})
export class PopupPrecosPracaPedagioComponent implements OnInit {

  loading: boolean = false;

  concesssionaria = '';
  displayAceitaTag = '';
  displayFreeFlow = '';
  displayOcAbertaAviso = '';
  idPracaPedagio = 0;
  km = '';
  praca = '';
  rodovia = '';
  porcTagDesconto = 0
  pracasPrecos = []
  dataAtualizacao?: String = null;
  veiculoDestaqueID: any

  constructor(
    private conService: ApiConService,
    private truckInfoService: TruckInfoService,
    private svgService: SvgService,
    private sanitizer: DomSanitizer,
    private boxListTruckService: BoxListTruckService
  ) { }

  ngOnInit(): void {

  }
  getIcone(tipoVeiculo: number) {
    switch (tipoVeiculo) {
      case 1:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.motocicletaPopup);
      case 2:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.auto2eixosPopup);
      case 3:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.auto3eixosPopup);
      case 4:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.auto4eixosPopup);
      case 5:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao2eixosPopup);
      case 6:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao3eixosPopup);
      case 7:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao4eixosPopup);
      case 8:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao5eixosPopup);
      case 9:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao6eixosPopup);
      case 10:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao6eixosPopup);
      case 11:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao6eixosPopup);
      case 12:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao6eixosPopup);
      case 13:
        return this.sanitizer.bypassSecurityTrustHtml(this.svgService.icones.caminhao6eixosPopup);
    }
  }

  async atualizarDados() {
    let objPrecosPedagio = window.globalThis['objPrecosPedagio']
    this.concesssionaria = objPrecosPedagio.concesssionaria;
    this.displayAceitaTag = objPrecosPedagio.displayAceitaTag;
    this.displayFreeFlow = objPrecosPedagio.displayFreeFlow;
    this.displayOcAbertaAviso = objPrecosPedagio.displayFreeFlow;
    this.idPracaPedagio = objPrecosPedagio.idPracaPedagio;
    this.km = objPrecosPedagio.km;
    this.praca = objPrecosPedagio.praca;
    this.rodovia = objPrecosPedagio.rodovia;
    this.porcTagDesconto = objPrecosPedagio.porcTagDesconto;
    this.veiculoDestaqueID = JSON.parse(this.boxListTruckService.listTruckService.InfoRota).CategoriaPedagioID;

    try {
      this.dataAtualizacao = null;
      this.loading = true;
      let result = await this.conService.patch(`DCPedagioOcorrencia/TabelaValoresPraca/${this.idPracaPedagio}`);
      this.atualizaListPracasPrecos(result.response)
      this.dataAtualizacao = await this.getDataAtualizacaoPraca();
    } catch (e) {
      console.log("Erro ao consultar tabela de preços " + e)
    } finally {
      this.loading = false;
    }
  }

  atualizaListPracasPrecos(listaPrecos) {
    this.pracasPrecos = listaPrecos;
    this.pracasPrecos.forEach((itemPreco) => {
      itemPreco.tipoVeiculo = this.truckInfoService.categoriaPedagiosVeiculos.find((elememt) => elememt.codCategoriaPedagio == itemPreco.CodCategoriaPedagio).descricao
    }
    )
  }

  async getDataAtualizacaoPraca() {
    let result = await this.conService.patch(`DCPedagioOcorrencia/DataAtualizacaoPraca/${this.idPracaPedagio}`);
    if (result.response.length > 0) {
      let dataAtual = new Date(result.response[0].dataApuracao);
      dataAtual.setDate(dataAtual.getDate() + 1)
      return dataAtual.toDateString();
    }
    return null;
  }
}
